import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.function.name";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

var ButtonGroup =
/*#__PURE__*/
function (_Component) {
  _inherits(ButtonGroup, _Component);

  function ButtonGroup() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ButtonGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ButtonGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "measureWidth", function (button) {
      if (button && (_this.state.minWidth < button.clientWidth || !_this.state.minWidth)) {
        _this.setState({
          minWidth: button.clientWidth
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (value) {
      return function (event) {
        var _this$props = _this.props,
            name = _this$props.name,
            onChange = _this$props.onChange;
        event.preventDefault();
        onChange({
          value: value,
          name: name
        });
      };
    });

    return _this;
  }

  _createClass(ButtonGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          selectedValue = _this$props2.selectedValue,
          justification = _this$props2.justification,
          values = _this$props2.values;
      var Content = null;

      switch (justification) {
        case 'same-size':
          {
            Content = function Content(props) {
              var style = {
                minWidth: _this2.state.minWidth,
                textAlign: 'center'
              };
              return React.createElement("div", {
                style: style,
                ref: _this2.measureWidth
              }, props.text);
            };

            break;
          }

        case 'wrap-content':
          {
            Content = function Content(props) {
              return React.createElement("div", null, props.text);
            };

            break;
          }

        default:
          {
            Content = function Content(props) {
              return React.createElement("div", null, props.text);
            };
          }
      }

      return React.createElement("div", {
        className: "button-group-buttons",
        role: "group"
      }, values.map(function (button) {
        // eslint-disable-next-line eqeqeq
        var selected = button.value == selectedValue;
        var listClassNames = classNames('button-group-button', {
          'button-group-button selected': selected
        });
        return React.createElement("button", {
          type: "button",
          "aria-pressed": selected,
          key: button.value,
          className: listClassNames,
          onClick: _this2.onClick(button.value)
        }, React.createElement(Content, {
          text: button.text
        }));
      }));
    }
  }]);

  return ButtonGroup;
}(Component);

_defineProperty(ButtonGroup, "propTypes", {
  values: PropTypes.array,
  selectedValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  justification: PropTypes.oneOf(['wrap-content', 'same-size']),
  onChange: PropTypes.func,
  name: PropTypes.string
});

_defineProperty(ButtonGroup, "defaultProps", {
  justification: 'wrap-content'
});

export default ButtonGroup;